import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import { MAX_WITH_MOBILE_MEDIA } from '../../config/getTheme';

const BlankContent = ({
  Icon,
  title,
  body,
  titleVariant,
  bodyVariant,
  buttonHelperText,
  ButtonComponent,
  iconSize = '2em'
}) => (
  <Box>
    <Stack alignItems='center' spacing={1} padding={2} paddingBottom={{sm: 2, md: 4}}>
      <Stack direction='row' spacing={1} alignItems='center'>
        {
          Icon ?
            <Icon sx={{ fontSize: iconSize, color: config().colors.primary }} />
            : null
        }
        {
          title &&
          <Typography
            variant={titleVariant || 'h3'}
            color='text.light'
            sx={{
              fontWeight: 500,
              [MAX_WITH_MOBILE_MEDIA]: {
                fontSize: '1rem',
              },
            }}
          >
            {title}
          </Typography>
        }
      </Stack>
      {
        body
          ? <Typography variant={bodyVariant || 'body1'} color='text.light' align='center'> {body} </Typography>
          : null
      }
      {
        buttonHelperText
          ? <Typography variant='large' color='text.light' align='center'>
            {buttonHelperText}
          </Typography>
          : null
      }
      {ButtonComponent}
    </Stack>
  </Box>
);

export default BlankContent;

